import { Box } from '@mui/material'
import React from 'react'

const cardBodyStyle = {
  padding: '0.9375rem 20px',
  flex: '1 1 auto',
  WebkitBoxFlex: 1,
  position: 'relative' as const,
}

type Props = {
  children?: React.ReactNode
}

export default function CardBody({ children }: Readonly<Props>) {
  return (
    <Box sx={cardBodyStyle} data-testid="card-body">
      {children}
    </Box>
  )
}
